// NPM/System Imports
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";

// Global Var Imports
import dimensions from "../styles/dimensions";
import colors from "../styles/colors";

// Component Imports
import Hero from "../components/about/Hero"
import DetailLeft from "../components/process/DetailLeft";
import DetailRight from "../components/process/DetailRight";
import Layout from "../components/Layout";
import CTACard from "../components/CTACard";

const Section = styled("section")`
    margin-bottom: 10em;
    display: flex;
    flex-direction: column;

    @media(max-width:${dimensions.maxwidthTablet}px) {
        margin-bottom: 4em;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`

const RenderBody = ({ process, meta }) => (
  <>
    <Helmet
        title={meta.title}
        titleTemplate={`%s | ${meta.title}`}
        meta={[
            {
                name: `description`,
                content: meta.description,
            },
            {
                property: `og:title`,
                content: meta.title,
            },
            {
                property: `og:description`,
                content: meta.description,
            },
            {
                property: `og:type`,
                content: `website`,
            },
            {
                name: `twitter:card`,
                content: `summary`,
            },
            {
                name: `twitter:creator`,
                content: meta.author,
            },
            {
                name: `twitter:title`,
                content: meta.title,
            },
            {
                name: `twitter:description`,
                content: meta.description,
            },
        ].concat(meta)}
    />

    <Hero
      headline={process.hero_title}
      copy={process.hero_subtitle}
      image={process.hero_image}
    />

    <DetailLeft
        headline={process.step_1_title}
        copy={process.step_1_copy}
        image={process.step_1_image}
    />

    <DetailRight
        headline={process.step_2_title}
        copy={process.step_2_copy}
        image={process.step_2_image}
    />

    <DetailLeft
        headline={process.step_3_title}
        copy={process.step_3_copy}
        image={process.step_3_image}
    />

    <CTACard 
      title={process.cta_title}
      copy={process.cta_copy}
      image={process.cta_image}
      link_text={process.cta_link_text}
      link_target={process.cta_link_target.url}
    />  
      
  </>
);

export default ({ data }) => {
    //Required check for no data being returned
    const doc = data.prismic.allProcesss.edges.slice(0, 1).pop();
    const meta = data.site.siteMetadata;

    if (!doc) return null;

    return (
        <Layout>
            <RenderBody process={doc.node} meta={meta}/>
        </Layout>
    )
}

RenderBody.propTypes = {
    process: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
};

export const query = graphql`
{
    prismic {
        allProcesss {
            edges {
            node {
                hero_title
                hero_subtitle
                hero_image
                step_1_title
                step_1_copy
                step_1_image
                step_2_title
                step_2_copy
                step_2_image
                step_3_title
                step_3_copy
                step_3_image
                cta_title
                cta_copy
                cta_image
                cta_link_text
                cta_link_target {
                    ... on PRISMIC__ExternalLink {
                    _linkType
                    url
                    }
                }
                meta_title
                meta_description
                og_title
                og_description
                og_image
            }
            }
        }
    }
    site {
        siteMetadata {
            title
            description
            author
        }
    }
}
`